import client from "common/admin/client";
import axios from "axios";
const uploadAndGenerateFileUrl = async (file, returnOnlyUrl) => {
  const action = resourceFactory("gcp_services/generateSignedUrl");
  try {
    const data = await action.create({ fileName: file.name });
    await axios({
      url: data.url,
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: file,
    });
    return returnOnlyUrl ? data.publicUrl : { url: data.publicUrl };
  } catch (error) {
    throw error;
  }
};
const concatImages = async (files) => {
  return new Promise(async (resolve, reject) => {
    const body = [];
    for (let i in files) {
      const file = files[i];
      if (file) {
        const response = await uploadAndGenerateFileUrl(file);
        body.push(response.url);
      }
    }
    resolve({ url: body.join(",") });
  });
};
const resourceFactory = (resource) => ({
  create: (props, noStringify) =>
    client.post(resource, { body: props, noStringify }),
  getAll: (query) => {
    return client.get(resource, { query });
  },
  getOne: (id) => {
    return client.get(`${resource}/${id}`);
  },
  update: (id, props) => client.patch(`${resource}/${id}`, { body: props }),
  removeOne: (id) => client.del(`${resource}/${id}`),
  removeOneWithBody: (id, props) =>
    client.del(`${resource}/${id}`, { body: props }),
  attachFiles: async (id, files) => {
    const body = {};
    for (let i in files) {
      const { file, prop, isMultiple } = files[i];
      if (file && isMultiple) {
        const response = await concatImages([...file]);
        body[prop] = response.url;
      }
      if (file && !isMultiple) {
        const response = await uploadAndGenerateFileUrl(file);
        body[prop] = response.url;
      }
    }
    if (!Object.keys(body).length) {
      return Promise.resolve();
    }
    return client.patch(`${resource}/${id}`, { body });
  },
  getURLForFiles: async (files) => {
    const promiseArray = files.map((file) => {
      if (file.src) {
        return file.src;
      }
      return uploadAndGenerateFileUrl(file, true);
    });
    return Promise.all(promiseArray);
  },
});

export default resourceFactory;
